import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getCurrencyPairs = ({ pageNumber = 1 }) => {
  return axios.get(`/transaction/swap/currencyPairs/${pageNumber}`);
};

export const useCurrencyPairs = ({ pageNumber = 1, config }) => {
  return useQuery({
    ...config,
    queryKey: ['currencyPairs', pageNumber],
    queryFn: () => getCurrencyPairs({ pageNumber }),
  });
};
